import * as AjaxFunctions from './instructorAjaxFunctions';

function handleLogin(results, userType){
   window.localStorage.setItem('authToken', results.id);
   window.localStorage.setItem('userId', results.userId);
   window.localStorage.setItem('userType', userType);
   
   if(userType === 'organization') {
      window.localStorage.setItem('userOrganizationId', results.userId);
      window.localStorage.setItem('userTitle', results.userTitle);
   }
   else {
      window.localStorage.setItem('userOrganizationId', results.organizationId);
   }
   window.location = '/'
}


window.onload = async function () {
   if(!window.globals){
      window.globals = {};
   }
   window.globals.doLogin = async () => {
      let username = document.getElementById('username').value;
      let password = document.getElementById('password').value;
      let results = null;
      try {
         results = await AjaxFunctions.loginAdmin(username, password);
         handleLogin(results, 'admin');
      }
      catch (e){}

      if(!results){
         try {
            results = await AjaxFunctions.loginInstructor(username, password);
            handleLogin(results, 'instructor');
         }
         catch (e) {}
      }

      if(!results){
         try {
            results = await AjaxFunctions.loginOrganization(username, password);
            handleLogin(results, 'organization');
         }
         catch (e) {}
      }

      if(!results){

         alert('Invalid username/password')
      }



      window.localStorage.setItem('authToken', results.id);
      window.localStorage.setItem('userId', results.userId);
      window.localStorage.setItem('organizationId', results.organizationId);
   }
};
